import {useRef} from "react";
import {Button, Form, Input} from "antd";
import BridgeUI from "./BridgeUI";

export default function SurveySaveAsPlan({onOk}) {
    const formRef = useRef()

    const onFinish = () => {
        const data = formRef.current.getFieldsValue()
        onOk && onOk(data)
    }

    return (
        <>
            <Form
                ref={formRef}
                layout={'vertical'}
                size={'small'}
            >
                <Form.Item
                    name={'title'}
                    label={'Title'}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={'shortId'}
                    label={'Short Identifier'}
                >
                    <Input />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" onClick={onFinish}>
                        Ok
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}